import { FC, useState } from 'react';
import { Button } from '@mui/material';

import { FilterIcon } from '../../../../components/icons/FilterIcon';
import AllFiltersDrawer from './AllFiltersDrawer';

const AllFiltersButton: FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Button
                variant="text"
                endIcon={<FilterIcon />}
                onClick={() => setIsOpen(true)}
                sx={(theme) => ({
                    color: theme.palette.text.secondary,
                    textTransform: 'none',
                    fontWeight: 400,
                    minWidth: '100px',
                    '&:hover': {
                        backgroundColor: 'transparent',
                    }
                })}
            >
                All Filters
            </Button>

            <AllFiltersDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </>
    );
};

export default AllFiltersButton;

